import { Navigate, Outlet } from 'react-router';
import { PATHS } from '@/routes/paths';
import { useOrganizationService } from '@/providers/organization-service-provider';

export function RequireOrganizationLayout(): React.ReactElement {
  const { hasOrganizationContext } = useOrganizationService();
  if (!hasOrganizationContext) {
    return <Navigate to={PATHS.selectOrganization} replace />;
  }
  return <Outlet />;
}
